(function (scope) {
  'use strict';
  const clamp = (x, min = 0, max = 1) => Math.min(max, Math.max(min, x));
  const hexPattern = /^#[0-9a-f]{6}$/i;
  function normalizeHex(value) {
    if (typeof value !== 'string' || !hexPattern.test(value.trim())) throw new Error('6桁のカラーコードを入力してください。例：#1565C0');
    return value.trim().toUpperCase();
  }
  function rgb(hex) {
    const h = normalizeHex(hex);
    return [1, 3, 5].map(i => parseInt(h.slice(i, i + 2), 16) / 255);
  }
  function luma(data, pixel) { return (data[pixel] * 0.2126 + data[pixel + 1] * 0.7152 + data[pixel + 2] * 0.0722) / 255; }
  function makeCalibration(base, reference, width, height, bodyMask) {
    const count = width * height, logo = new Float32Array(count), reflection = new Float32Array(count), matteReflection = new Float32Array(count), shade = new Float32Array(count);
    const xScale = width / 1024, yScale = height / 1536;
    for (let y = 0; y < height; y++) {
      const ry = y / yScale;
      for (let x = 0; x < width; x++) {
        const p = y * width + x, k = p * 4, rx = x / xScale;
        if (!bodyMask[p]) continue;
        let a = 0;
        if (rx >= 182 && rx <= 814 && ry >= 528 && ry <= 1010) {
          // The supplied matte reference separates the printed logo from reflections.
          const upper = (Math.round(515 * yScale) * width + x) * 4;
          const lower = (Math.round(1022 * yScale) * width + x) * 4;
          const baseline = luma(reference, upper) * (1 - clamp((ry - 515) / 507)) + luma(reference, lower) * clamp((ry - 515) / 507);
          const difference = luma(reference, k) - baseline;
          const matteConfidence = clamp((difference - 0.035) / 0.13);
          const saturationHint = clamp((base[k + 2] - base[k] - 0.7) / 2.2);
          const valueHint = clamp((luma(base, k) - 0.07) / 0.16);
          a = matteConfidence * Math.max(saturationHint, valueHint * 0.8);
          if (matteConfidence > 0.96 && valueHint > 0.9) a = 1;
        }
        logo[p] = a;
        const original = luma(base, k);
        // Recover highlights under the original charcoal ink, preserving their position.
        const clear = Math.max(0, (original - 0.322) / 0.678);
        reflection[p] = Math.pow(original * (1 - a) + clear * a, 2.2);
        const matte = luma(reference, k);
        matteReflection[p] = Math.pow(matte * (1 - a) + Math.max(0, (matte - 0.285) / 0.715) * a, 2.2) * 0.55;
        const horizontal = clamp((rx - 502) / 358, -1, 1);
        const roundness = Math.sqrt(Math.max(0, 1 - horizontal * horizontal));
        const shoulder = 1 - clamp((390 - ry) / 230) * 0.16;
        shade[p] = (0.2 + 0.62 * roundness) * shoulder;
      }
    }
    return { base, reference, width, height, bodyMask, logo, reflection, matteReflection, shade };
  }
  function render(calibration, tankHex, logoHex, output, finish = 'gloss') {
    if (!['gloss','matte'].includes(finish)) throw new Error('仕上げを選択してください。');
    const tank = rgb(tankHex).map(v => Math.pow(v, 2.2));
    const print = rgb(logoHex).map(v => Math.pow(v, 2.2));
    const { base, bodyMask, logo, reflection, shade } = calibration;
    const background = finish === 'matte' ? calibration.reference : base;
    output.set(background);
    for (let p = 0; p < bodyMask.length; p++) {
      const coverage = bodyMask[p];
      if (!coverage) continue;
      const k = p * 4, specular = finish === 'matte' ? calibration.matteReflection[p] : reflection[p], ink = logo[p];
      for (let c = 0; c < 3; c++) {
        const pigment = tank[c] * (1 - ink) + print[c] * ink;
        const linear = clamp(pigment * shade[p] * (1 - specular) + specular);
        const channel = Math.round(Math.pow(linear, 1 / 2.2) * 255);
        output[k + c] = Math.round(background[k + c] * (1 - coverage) + channel * coverage);
      }
    }
    return output;
  }
  function pricing(state) {
    const colors = new Set();
    for (const kind of ['tank','logo']) if (state[kind+'Oem']) {
      const designation = (state[kind+'Spec'] || '').normalize('NFKC').trim().toUpperCase().replace(/\s+/g,' ');
      colors.add(designation || '__UNSPECIFIED_'+kind);
    }
    return {base:66000,custom:5500,oemCount:colors.size,oem:colors.size*2200,total:71500+colors.size*2200};
  }
  const api = { normalizeHex, rgb, makeCalibration, render, pricing };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.VectoraneColorEngine = api;
})(typeof window !== 'undefined' ? window : this);
